import type { User } from "features/auth/authTypes.ts";
import { initialStatePermissions } from "features/permissions/permissionsTypes.ts";
import type {
  Permission,
  PermissionsParsed,
} from "features/permissions/permissionsTypes.ts";

const createPermission = (
  moduleName: keyof PermissionsParsed,
  overrides?: Partial<Permission>,
): Permission => ({
  id: 0,
  isCreate: false,
  isDelete: false,
  isRead: true,
  isUpdate: false,
  moduleId: 0,
  moduleName,
  roleId: "preview",
  ...overrides,
});

export const DEMO_USER: User = {
  amr: [],
  aud: [],
  auth_time: 0,
  client_id: "preview",
  email: "preview@rolfsonoil.com",
  exp: 0,
  idp: "preview",
  iss: "preview",
  name: "Preview User",
  nbf: 0,
  role: "PREVIEW",
  roleid: "preview",
  scope: [],
  sub: "preview",
  username: "preview",
};

const previewPermissions = { ...initialStatePermissions };

const readableModules: Array<keyof PermissionsParsed> = [
  "DashboardPage",
  "OrdersPage",
  "OrderBulkUpload",
  "TicketsPage",
  "CustomersPage",
  "SettingsList",
];

readableModules.forEach((moduleName) => {
  previewPermissions[moduleName] = createPermission(moduleName);
});

export const DEMO_PERMISSIONS: PermissionsParsed = previewPermissions;
